// Color scheme for cards - using brand color #19BA92 (teal/green) and complementary colors
export const cardColors = [
    {
      id: 0,
      bg: "bg-gradient-to-br from-primary-100/10 to-primary-100",
      border: "border-primary-300",
      accent: "bg-primary-200",
      text: "text-primary-900"
    },
    {
      id: 1,
        bg: "bg-gradient-to-br from-primary-100/10 to-white",
        border: "border-primary-300",
      accent: "bg-light-green-300/30",
      text: "text-primary-900"
    },
  ];